import kintFunctions from '~kint/firebase/functions.ts';
import { Team } from '~kint/models/Team.ts';

export default function callTeam(reservationId: string): Promise<Team | null> {
  return kintFunctions.call('callTeam', { reservationId });
}
